import React from "react";
import ProviderItem from "ComponentsUI/ProviderItem/ProviderItem";
import { Link } from "react-router-dom";
import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { CDN_URL } from "Constants/CDN";
import RecentlyConnectedTariffConnectHOC from "HOC/RecentlyConnectedTariffConnectHOC";

export default class ProviderItemContainer extends React.Component {
	generateProviderUrl(data) {
		if (data) {
			let providerUrl = generateUrl(Routes.ProviderDetails.route, {
				providerName: data.url_name,
				regionUrl: data.region.url,
			});
			return providerUrl;
		}
		return "/";
	}

	generateProviderRatesUrl(data) {
		if (data) {
			let providerRatesUrl = generateUrl(Routes.ProviderRates.route, {
				providerName: data.url_name,
				regionUrl: data.region.url,
			});
			return providerRatesUrl;
		}
		return "/";
	}

	generateLogoPath(item) {
		return item.logo
			? replaceStaticHost(item.logo)
			: replaceStaticHost(`${CDN_URL}/images/404.png`);
	}

	render() {
		return (
			<RecentlyConnectedTariffConnectHOC>
				<ProviderItem
					{...this.props}
					linkComponent={<Link to={"/"} />}
					generateLogoPath={(item) => this.generateLogoPath(item)}
					generateProviderUrl={(data) => this.generateProviderUrl(data)}
					generateProviderRatesUrl={(data) => this.generateProviderRatesUrl(data)}
					webpTransformer={webpTransformer}
				/>
			</RecentlyConnectedTariffConnectHOC>
		);
	}
}
